import { render, staticRenderFns } from "./im_content_expert.vue?vue&type=template&id=37b47e5d&scoped=true&"
import script from "./im_content_expert.vue?vue&type=script&lang=ts&"
export * from "./im_content_expert.vue?vue&type=script&lang=ts&"
import style0 from "./im_content_expert.vue?vue&type=style&index=0&id=37b47e5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b47e5d",
  null
  
)

export default component.exports